import { activitiesApi } from 'entities/activities';
import { ActivitiesListType } from 'entities/promo/types';
import { prepareQueryArrayParam } from 'shared/utils';

const getActivitiesApi = activitiesApi.injectEndpoints({
  endpoints: (builder) => ({
    getActivities: builder.query<
      ActivitiesListType,
      { app_type?: string; page?: number; size?: number; search?: string; activity_type_ids: number[] }
    >({
      query: ({ page, size, search, activity_type_ids }) => ({
        url: `/promo-b2b/admin/promo-b2b/admin/activities/?page=${page}&size=${size}${
          search ? `&search=${search}` : ''
        }${activity_type_ids.length ? `&${prepareQueryArrayParam('activity_type_id', activity_type_ids)}` : ''}`,
      }),
      providesTags: ['Activities'],
    }),
    getActivitiesById: builder.query({
      query: ({ id }) => ({
        url: `/promo-b2b/admin/promo-b2b/admin/activities/${id}/`,
      }),
      providesTags: ['ActivitiesId'],
    }),
  }),
  overrideExisting: false,
});

export const { useGetActivitiesQuery, useGetActivitiesByIdQuery } = getActivitiesApi;
